
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


export default {
name: "RepairSrvp",
components: {
Group,
XInput,
XButton,
Confirm,
Selector,
XTextarea,
Cell,
Previewer
},
directives: {
TransferDom
},
data() {
return {
options: {
getThumbBoundsFn(index) {
let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
let rect = thumbnail.getBoundingClientRect()
return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}
}
},
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
clearotherdesignateshow: false,
rejectshow: false,
orderDetail: {},
info: [],
list: [],
faststatusList: [{key: 'YES', value: '是'}, {key: 'NO', value: '否'}, {key: 'INVALID', value: '无效的申请'}],
faststatus: '',
fastplan: '',
roles: [{key: 'EXPT', value: '专家'}, {key: 'SRVP', value: '服务商'}],
reason: [{key: 'REJECT', value: '拒绝'}, {key: 'REGRET', value: '反悔'}, {
key: 'UNQUAL',
value: '不合格'
}, {key: 'TIMEOUT', value: '超时'}, {key: 'UCANCLR', value: '用户取消'}],
pay: [{key: 1, value: '是'}, {key: 0, value: '否'}],
closeList: [{key: '软件问题', value: '软件问题'},
{key: '网络问题', value: '网络问题'},
{key: '非正常使用导致的硬件损坏', value: '非正常使用导致的硬件损坏'},
{key: '正常使用时的硬件损坏', value: '正常使用时的硬件损坏'},
{key: '软硬件故障均有', value: '软硬件故障均有'},
{key: '技术咨询（如用户操作指导等）', value: '技术咨询（如用户操作指导等）'},
{key: '设备运输问题', value: '设备运输问题'},
{key: '外设、周边、附件问题', value: '外设、周边、附件问题'},
{key: '其他问题', value: '其他问题'}],
needpay: 0,
payment: '',
payprice: 0,
clean_reason: '',
clean_detail: '',
roleAccount: [],
expert: '',
confirminfo: '',
imgList: [],
filename:'',
filepath:'',
updateinfo: '',
address: '',
confirmshow: false,
againdesignateshow: false,
acceptshow: false,
assignshow: false,
updateshow: false,
closeshow: false,
close_advice: '',
close_fconfirm: '',
designateshow: false,
cleardesignateshow: false,
fastshow: false,
seq: this.$route.query.seq,
type: this.$route.query.type,
role: this.$route.query.role,
roleType: '',
roleid: '',
state: '',
fdetailList: [],
marketshow: false,
marketlist: [],
market: ''
}
},
methods: {
addMarket() {
this.$http.post('/api/v1/normalrepairs/' + this.seq + '/set_repair_visible_to', {
role: 'ADMIN',
userid: this.market.toString(),
user_type: 'EXPT',
visible: true
}, this.header).then(() => {
this.marketshow = false
}).catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
},

downloadFile(){
this.$router.push({
name: "Download",
query: {path:this.filepath, suffix:this.filename}
});
},
designateRouter(bol = false) {
if (bol) {
this.$router.push({
name: 'Desiginate',
query: {seq: this.seq, role: this.role, type: this.type, roleType: 'false'}
})
} else {
this.$router.push({
name: 'Desiginate',
query: {seq: this.seq, role: this.role, type: this.type, roleType: 'true'}
})
}
},
designateAgainRouter() {
this.$router.push({name: 'Desiginate', query: {seq: this.seq, role: this.role, type: this.type, again: true}})
},
format(num) {
return num.toLocaleString('zh', {maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: false});
},
show(index) {
this.$refs.previewer.show(index)
},
callPhone(phoneNumber) {
window.location.href = 'tel://' + phoneNumber
},
priceChange() {
try {
this.payprice = parseFloat(this.payment).toFixed(2);
this.payment = this.format(parseFloat(this.payment))
if (isNaN(this.payment)) {
alert('请输入正确价格');
this.payment = '0.00';
this.payprice = 0;
}
if (this.payprice === '0.00') {
if (!confirm('确认该订单服务费用0元')) {
this.payment = '';
this.payprice = 0;
}
}
} catch (e) {
alert('请输入正确价格');
this.payment = '0.00';
this.payprice = 0;
}
},
initView(orderDetail) {
this.address = orderDetail.province + ' ' + orderDetail.city + ' ' + orderDetail.district
orderDetail.isviwo = orderDetail.isviwo ? '是' : '否';
orderDetail.sevenday = orderDetail.sevenday ? '是' : '否';
if (this.role === 'ADMIN') {
switch (orderDetail.overall_status) {
case 'WAITPROCESS_WAITCONFIRM':
orderDetail.overall_name = '待处理';
break;
case 'WAITPROCESS_WAITCONFIRM_CANCEL':
orderDetail.overall_name = '待处理,用户已取消';
break;
case 'WAITPROCESS_CONFIRMED':
orderDetail.overall_name = '待处理,故障已确认';
break;
case 'WAITPROCESS_CONFIRMED_CANCEL':
orderDetail.overall_name = '待处理，故障已确认，用户已取消';
break;
case 'PROCESSING_WAITCONFIRM':
orderDetail.overall_name = '处理中';
break;
case 'PROCESSING_WAITCONFIRM_CANCEL':
orderDetail.overall_name = '处理中，用户已取消';
break;
case 'PROCESSING_CONFIRMED':
orderDetail.overall_name = '处理中，故障已确认';
break;
case 'PROCESSING_CONFIRMED_CANCEL':
orderDetail.overall_name = '处理中，故障已确认，用户已取消';
break;
case 'PROCESSED_CONFIRMED':
orderDetail.overall_name = '处理完成，待关闭';
break;
case 'ASSIGNED':
orderDetail.overall_name = '已指派，待接单';
break;
case 'ASSIGNED_CANCEL':
orderDetail.overall_name = '已指派，用户已取消';
break;
case 'PROCESSED_WAIT':
orderDetail.overall_name = '处理完成，等待用户确认';
break;
case 'PROCESSED_ARBIT':
orderDetail.overall_name = '处理完成，等待仲裁';
break;
default:
break;
}
} else {
switch (orderDetail.overall_status) {
case 'PROCESSING_WAITCONFIRM':
orderDetail.overall_name = '处理中';
break;
case 'PROCESSING_WAITCONFIRM_CANCEL':
orderDetail.overall_name = '处理中，用户已取消';
break;
case 'PROCESSING_CONFIRMED':
orderDetail.overall_name = '处理中，故障已确认';
break;
case 'PROCESSING_CONFIRMED_CANCEL':
orderDetail.overall_name = '处理中，故障已确认，用户已取消';
break;
case 'PROCESSED_CONFIRMED':
orderDetail.overall_name = '处理完成';
break;
case 'ASSIGNED':
orderDetail.overall_name = '待接单';
break;
case 'ASSIGNED_CANCEL':
orderDetail.overall_name = '用户已取消';
break;
default:
break;
}
}
switch (orderDetail.userconfirm) {
case 'ACCEPT':
orderDetail.userconfirm = '接受'
break
case 'WAIT1':
orderDetail.userconfirm = '等待确认'
break
case 'WAIT2':
orderDetail.userconfirm = '等待确认'
break
case 'REJECT':
orderDetail.userconfirm = '拒绝'
break
case 'ARBIT':
orderDetail.userconfirm = '提交仲裁'
break
case 'A_ACCEPT':
orderDetail.userconfirm = '后台自动确认'
break
}
switch (orderDetail.state) {
case 'WAIT':
this.state = '待处理'
break
case 'PROCESS':
this.state = '处理中'
break
case 'FAIL':
this.state = '失败'
break
case 'SUCCESS':
this.state = '成功'
break
}
if (!this.type) {
if (this.role === 'ADMIN') {
this.type = 'false'
} else {
switch (orderDetail.state) {
case 'WAIT':
this.type = 'accept'
break
case 'PROCESS':
this.type = 'process'
break
case 'FAIL':
this.type = 'done'
break
case 'SUCCESS':
this.type = 'done'
break
}
}
}
switch (orderDetail.needpay) {
case 'WAIT':
orderDetail.needpay = '待支付';
break;
case 'NO':
orderDetail.needpay = '不需要支付';
break;
case 'PAYED':
orderDetail.needpay = '已支付';
break;
}
if (orderDetail.needpay) {
orderDetail.initpay = this.format(orderDetail.initpay)
}
this.imgList = [];
if (orderDetail.signature && orderDetail.signature.content.length !== 0) {
if(orderDetail.signature.content[0].describe==""){
orderDetail.signature.content[0].path.forEach(item => {
this.$http.get('/api/photos?path=' + item.thumb, this.header).then(paths => {
this.imgList.push({src: paths.data['value']});
});
});
}else{
this.filename = orderDetail.signature.content[0].describe
this.filepath = orderDetail.signature.content[0].path[0].origin
}


}
this.fdetailList = []
if (orderDetail.fdetail && orderDetail.fdetail.content.length !== 0) {
if (orderDetail.fdetail.version === '1.1') {
orderDetail.fdetail.content[0].path.forEach(item => {
this.$http.get('/api/photos?path=' + item['origin'], this.header).then(paths => {
this.fdetailList.push({src: 'data:image/jpeg;base64,' + paths.data['value']})
})
})
} else {
orderDetail.fdetail.content[0].path.forEach(item => {
this.$http.get('/api/photos?path=' + item, this.header).then(paths => {
this.fdetailList.push({src: 'data:image/jpeg;base64,' + paths.data['value']})
})
})
}
}
return orderDetail;
},
accpet() {
this.$http.post('/api/v1/normalrepairs/' + this.seq + '/order', {
role: 'SRVP',
op: 'ACCEPT',
comment: this.comment
}, this.header)
.then(() => {
alert('已接受该订单');
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
},
confirmRejct() {
this.$http.post('/api/v1/normalrepairs/' + this.seq + '/reject_repair_result', {reason: this.$refs.rejectorder.msg}, this.header)
.then(() => {
alert('已驳回该订单')
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
}).catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
});
},
reject() {
this.$http.post('/api/v1/normalrepairs/' + this.seq + '/order', {
role: 'SRVP',
op: 'REJECT',
comment: this.comment
}, this.header)
.then(() => {
alert('已拒绝该订单');
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
},
assign() {
let userid;
this.info.forEach(item => {
if (this.expert === item.name) {
userid = item.userid;
}
})
this.$http.post('/api/v1/normalrepairs/' + this.seq + '/transfer', {
role: 'SRVP',
account: userid.toString()
}, this.header)
.then(() => {
alert('指派成功');
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
});
},
confrm() {
let result;
switch (this.confirminfo) {
case '是':
result = 'YES';
break;
case '否':
result = 'NO';
break;
case '无效':
result = 'INVALID';
break;
case '等待':
result = 'WAIT';
break;
}
this.$http.put('/api/v1/normalrepairs/' + this.seq + '/confirm', {role: this.role, result}, this.header)
.then(() => {
alert('确认故障成功');
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
});
},
update() {
let result = this.updateinfo === '成功' ? 'SUCCESS' : 'FAIL';
this.$http.put('/api/v1/normalrepairs/' + this.seq + '/result', {role: this.role, result}, this.header)
.then(() => {
alert('更新成功');
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
});
},
searchType(num) {
if (this.type === 'accept') {
this.acceptshow = true;
} else if (this.type === 'process' || this.type === 'false') {
switch (num) {
case 1:
this.list = [];
this.designateRouter()
break;
case 2:
this.confirmshow = true;
break;
case 3:
this.$router.push({name: 'finish', params: {obj: this.orderDetail, type: this.role}})
/*this.updateshow = true;*/
break;
case 4:
this.$router.push({name: 'Askpay', params: {seq: this.seq, role: this.role, type: this.type}})
break;
}
}
},
close() {
this.$http.get('/api/v1/normalrepairs/' + this.seq + '/close?advice=' + this.close_advice + '&fconfirm=' + this.close_fconfirm, this.header)
.then(() => {
alert("已关闭");
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
},
designateChange() {
this.roleAccount = [];
if (this.roleType === 'EXPT') {
this.$http.get('/api/v1/experts?offset=0&count=999&type=audit', this.header)
.then(response => {
response.data['list'].forEach(item => {
this.roleAccount.push({value: item.detail.name, key: item.userid})
})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
} else {
this.$http.get('/api/v1/agencies?offset=0&count=999&type=audit', this.header)
.then(response => {
response.data['list'].forEach(item => {
this.roleAccount.push({value: item.detail.company, key: item.userid})
})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}
},
designate() {
this.$http.post('/api/v1/normalrepairs/' + this.seq, {
"account": this.roleid.toString(),
"role": this.roleType,
"needpay": this.needpay,
"payment": this.payprice
}, this.header)
.then(() => {
alert("指派成功");
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
},
cleardesignate() {
this.$http.put('/api/v1/normalrepairs/' + this.seq + '/clear', {
"reason": this.clean_reason,
"detail": this.clean_detail
}, this.header)
.then(() => {
alert('清除成功');
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
},
clearotherdesignate() {
this.$http.post('/api/v1/normalrepairs/' + this.seq + '/clear_assign_to_assist', {
"reason": this.clean_reason,
"detail": this.clean_detail,
role: 'SRVP'
}, this.header).then(response => {
alert('清除成功');
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
},
againdesignate() {
this.$http.put('/api/v1/normalrepairs/' + this.seq + '/reassign', {
'account': this.roleid.toString(),
'role': this.roleType,
needpay: this.needpay,
payment: this.payprice,
reason: this.clean_reason,
detail: this.clean_detail
}, this.header).then(() => {
alert('改派成功')
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
},
fast() {
this.$http.put('/api/v1/fastrepairs/' + this.seq, {
'confirm': this.faststatus,
'solution': this.fastplan
}, this.header)
.then(() => {
alert('确认订单成功');
this.$router.push({name: 'FastRepairOrder'})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}
},
beforeRouteEnter(to, from, next) {
next(vm => {
const unionid = localStorage.getItem('unionid')
let account
AjaxPlugin.$http.get('api/v1/wechat/' + unionid).then((res) => {
res.data.forEach(item => {
if (item.role === to.query.role) {
account = item.account
}
})
AjaxPlugin.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account}).then(response => {
localStorage.setItem('token', response.data.token)
localStorage.setItem('userid', response.data.userid)
vm.header = {
headers: {
token: response.data.token,
opid: response.data.userid
}
}
if (to.query.type && (to.query.type === 'fast-false' || to.query.type === 'fast-true')) {
AjaxPlugin.$http.get('api/v1/fastrepairs/' + to.query.seq, vm.header).then(response => {
localStorage.setItem('order', JSON.stringify(response.data.detail))
vm.orderDetail = vm.initView(response.data.detail);
}).catch(error => {
console.log(error)
vm.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
} else {
AjaxPlugin.$http.get('api/v1/normalrepairs/' + to.query.seq + '?role=' + to.query.role + '&type=detail', vm.header).then(response => {
localStorage.setItem('order', JSON.stringify(response.data.detail))
vm.orderDetail = vm.initView(response.data.detail);
}).catch(error => {
console.log(error)
vm.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}
})
})
})
},
beforeRouteLeave(to, from, next) {
if (to.name === 'RepairOrder') {
to.params.isAdmin = this.role === 'ADMIN';
} else if (to.name === 'list') {
to.params.role = this.isAdmin ? 'ADMIN' : 'SRVP';
}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/repairs/RepairSrvp.vue